import { render, staticRenderFns } from "./TdClient.vue?vue&type=template&id=efc406c0&scoped=true&"
import script from "./TdClient.vue?vue&type=script&lang=js&"
export * from "./TdClient.vue?vue&type=script&lang=js&"
import style0 from "./TdClient.vue?vue&type=style&index=0&id=efc406c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc406c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
